'use client';

import NotFound from '@/legacy/routes/not-found';

export default function AppNotFoundPage() {
  return <NotFound />;
}
